import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'highlight',
    standalone: false
})
export class HighlightPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  private escapeHtml(str: string): string {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  private escapeForRegex(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  transform(
    value: string | null | undefined,
    search: string | null | undefined,
    tailwindClasses = 'bg-yellow-300 text-black dark:bg-yellow-700 dark:text-white rounded px-1',
    caseSensitive = false,
    wholeWord = false
  ): SafeHtml {
    if (!value) return this.sanitizer.bypassSecurityTrustHtml('');
    if (!search) return this.sanitizer.bypassSecurityTrustHtml(this.escapeHtml(value));

    const safeText = this.escapeHtml(value);
    const safeSearch = this.escapeHtml(search);
    const regexEscaped = this.escapeForRegex(safeSearch);
    const boundary = wholeWord ? '\\b' : '';
    const flags = caseSensitive ? 'g' : 'gi';
    const regex = new RegExp(boundary + regexEscaped + boundary, flags);

    const replaced = safeText.replace(
      regex,
      (match) => `<span class="${tailwindClasses}">${match}</span>`
    );

    return this.sanitizer.bypassSecurityTrustHtml(replaced);
  }
}
